import Icon from "elements/Icon";
import Colors from "modules/Colors";
import { clsx, styx } from "modules/Utils";
import { CSSProperties } from "react";

interface PreviewContentEmptyStateProps {
    className: string;
    style?: CSSProperties;
    title?: string;
    subtitle?: string;
    icon?: string;
}

const PreviewContentEmptyState = ({
    className,
    style,
    title,
    subtitle,
    icon,
}: PreviewContentEmptyStateProps) => {
    return (
        <div
            className={clsx('previewContentEmptyStateComponent', className)}
            style={styx(sty.previewContentEmptyStateComponent, style)}
        >
            {icon &&
                <Icon
                    className="previewContentEmptyStateIcon"
                    icon={icon}
                    size={52}
                    color={Colors.white}
                />
            }
            {title &&
                <div className="previewContentEmptyStateTitle">
                    {title}
                </div>
            }
            {subtitle &&
                <div className="previewContentEmptyStateSubtitle">
                    {subtitle}
                </div>
            }
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    previewContentEmptyStateComponent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        aspectRatio: '1/1',
        border: '1px solid rgba(255, 255, 255, 0.70)',
        borderRadius: 16,
        width: '100%',
        opacity: 0.5,
    },
}

export default PreviewContentEmptyState;